export default {
  //заполнить список типов партнеров
  loadRequestCategories(state, data){
    state.items=data;
  },
}
